/**
 * Utility class for impact calculation operations
 * Centralizes common calculations to avoid duplication
 */
export type ViewMode = 'group' | 'individual';

export class ImpactCalculator {
  /**
   * Adjust impact value based on view mode (group or per traveler)
   */
  static adjustForViewMode(
    impact: number,
    viewMode: ViewMode,
    travelers: number
  ): number {
    return viewMode === 'individual' ? impact / (travelers || 1) : impact;
  }

  /**
   * Calculate percentage of a value relative to total
   */
  static calculatePercentage(value: number, total: number): number {
    return total > 0 ? Math.round((value / total) * 100) : 0;
  }

  /**
   * Calculate main transport impact from transport array
   */
  static calculateMainTransportImpact(
    transports: Array<{ impact: number; isMainTransport: boolean }>
  ): number {
    return transports
      .filter((t) => t.isMainTransport)
      .reduce((sum, t) => sum + t.impact, 0);
  }
}
